import React from 'react';
import { Modal } from './index';
import { Loading } from '../loading';
var LoadingModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, sizeModal = _a.sizeModal, sizeSpinner = _a.sizeSpinner, className = _a.className, classNameTittle = _a.classNameTittle, loadingTitle = _a.loadingTitle;
    return (React.createElement(Modal, { isOpen: isOpen, size: sizeModal, className: 'loading-modal ' + (className ? className : ''), onClose: onClose ? onClose : undefined },
        React.createElement(Loading, { color: 'primary', size: sizeSpinner || 'xl', className: 'd-flex flex-direction-row justify-content-center', classNameSpinner: 'm-0' }),
        React.createElement("p", { className: classNameTittle ? classNameTittle : 'loading-title' }, loadingTitle)));
};
export { LoadingModal };
//# sourceMappingURL=LoadingModal.js.map